<template>
  <HeadWithLogo/>
  <p class="text-justify">
    دسترسی به نرم افزار برخط ناظر یک ، صرفا برای کسانی که امکان ورود ایشان توسط پلیس امنیت اخلاقی فرماندهی نیروی انتظامی جمهوری اسلامی فعال شده باشد، امکان پذیر است.
    در این نرم افزار پس از اینکه فردِ دارای دسترسی، شماره پلاک خودرویی که در آن کشف حجاب کامل شده است (در تاریخ، ساعت و مکان معین ) را ثبت میکند، در عرض چند ثانیه پیامک اخطار به مالک خودرو ارسال میگردد.
  </p>
  <div class="row mt-3">
    <div class="col-6 text-end">
      <RouterLink to="/intro" class="btn btn-success px-3">
        صفحه قبل
      </RouterLink>
    </div>
    <div class="col-6 text-start">
      <RouterLink to="/introThird" class="btn btn-success px-3">
        صفحه بعد
      </RouterLink>
    </div>
  </div>
</template>
<style>
.intro-text {
  font-family: Calibri, sans-serif;
}
</style>
<script>
import HeadWithLogo from "@/components/HeadWithLogo";

export default {
  components: {HeadWithLogo}
}
</script>
